<div class="page container textstorecord">
  @if (this.seances.length > 0) {
<div
   
    class="d-flex align-items-center justify-content-between mb-4"
  >
    <div class="d-flex align-items-center">
      <div class="form-floating">
        <select
          #seanceSelect
          class="select form-select"
          placeholder=""
          (change)="this.getPvsBySeance(parseInt(seanceSelect.value))"
        >
          @for (seance of this.seances; track seance) {
<option [value]="seance.id">
            Séance {{seance.type === 'ON AIR' ? 'On Air' : ''}} {{ seance.langue }} du
            {{ seance.date_creation | date : "dd/MM/yyyy" }}
          </option>
}
        </select>
        <label for="">Séance</label>
      </div>

      <div class="ms-3">
        <div class="text-info">
          {{ this.selectedSeance.compteur_done }} texte{{
            this.selectedSeance.compteur_done > 1 ? "s" : ""
          }}
          livré{{ this.selectedSeance.compteur_done > 1 ? "s" : "" }} sur
          {{ this.selectedSeance.compteur_todo }}
        </div>
        @if (this.standByPV.length > 0) {
<div class="text-danger">
          {{ this.standByPV.length }} texte{{ this.standByPV.length > 1 ? "s" : "" }} en
          standby
        </div>
}
      </div>
    </div>
    <div>
      <button
        class="btn btn-primary me-3"
        (click)="this.readerDialogVisible = true"
        [disabled]="isFetching"
      >
        <i class="fa-solid fa-glasses"></i>
        Mode lecture
      </button>
      <button class="btn btn-primary" (click)="this.savePDF()" [disabled]="isFetching">
        <i class="fa-solid fa-file-pdf"></i> Télécharger le PDF la séance
      </button>
    </div>
  </div>
} @else {

    @if (!this.isFetching) {
<div>Aucun texte à enregistrer pour le moment</div>
}
  
}
  

  @if (this.isFetching) {
<div class="textstorecord__loader">
    <app-loader />
  </div>
}
  @if (!this.isFetching) {
<app-texts-list
   
    [textsList]="this.assignedPVs"
    [todo]="this.textsTodo.RECORD"
    [phasesVocales]="this.phasesVocalesList"
    [standbyTypes]="this.standbyTypes"
    (showCommentDialogEvent)="this.onShowCommentDialog($event)"
    (showStandbyDialogEvent)="this.onShowStandbyDialog($event)"
  />
}

  <app-dialog
    #standbyDialog
    title="Mettre en standby"
    [visibility]="this.standbyDialogVisible"
    (closeDialogEvent)="this.standbyDialogVisible = $event"
  >
    @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div
     
      [formGroup]="this.standbyForm"
    >
      <div class="form-floating mb-2">
        <select
          [ngClass]="{ 'is-invalid': this.standbyTypeInput?.invalid }"
          name=""
          id=""
          class="form-select"
          formControlName="standbyTypeInput"
        >
          <option value="">Sélectionnez un motif</option>
          @for (zby of this.standbyTypes; track zby) {
<option [value]="zby.cc_code">
            {{ zby.cc_libelle }}
          </option>
}
        </select>
        <label for="" class="form-label">Motif</label>
      </div>
      <div class="form-floating">
        <textarea
          formControlName="standbyMessageInput"
          name=""
          id=""
          placeholder=""
          rows="10"
          class="form-control"
        ></textarea>
        <label for="" class="form-label">Commentaire</label>
      </div>
    </div>
}

    <app-post-states
      [isPosting]="this.isPosting"
      [isPostingOver]="this.isPostingOver"
      [postError]="this.postError"
      postingMessage="Le texte est en cours de modification"
      completeMessage="Le texte a bien été mis en standby"
    />
    <div dialog-footer>
      @if (!this.isPosting && !this.isPostingOver && !this.postError) {
<div>
        <button
          class="btn btn-success me-2"
          (click)="this.standby()"
          [disabled]="this.standbyTypeInput?.invalid || this.isPosting"
        >
          Valider
        </button>
        <button
          class="btn btn-danger"
          (click)="standbyDialog.closeDialog()"
        >
          Annuler
        </button>
      </div>
}
      @if (this.postError) {
<div>
        <button
          class="btn btn-danger me-2"
          (click)="standbyDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
      @if (this.isPostingOver) {
<div>
        <button
          class="btn btn-success me-2"
          (click)="standbyDialog.closeDialog()"
        >
          Fermer
        </button>
      </div>
}
    </div>
  </app-dialog>

  <app-dialog
    #commentDialog
    title="Commentaire après enregistrement"
    [visibility]="this.commentDialogVisible"
    (closeDialogEvent)="this.commentDialogVisible = $event"
  >
    <div class="form-floating">
      <textarea name="" id="" placeholder="" class="form-control"></textarea>
      <label for="">Commentaire </label>
    </div>
    <div dialog-footer>
      <button class="btn btn-success me-2">Valider</button>
      <button class="btn btn-danger" (click)="commentDialog.closeDialog()">
        Annuler
      </button>
    </div>
  </app-dialog>

  @if (this.selectedSeance) {
<app-dialog
   
    title="Séance {{ this.selectedSeance.id }} du
        {{ this.selectedSeance.date_creation | date : 'dd/MM/yyyy' }}"
    [visibility]="this.readerDialogVisible"
    (closeDialogEvent)="this.readerDialogVisible = $event"
    [largeContent]="true"
    [customWidth]="1100"
  >
    @for (text of this.assignedPVs; track text) {
<div class="mb-4">
      <div class="textstorecord__readermode">
        <div class="textstorecord__readermode__text">
          <h6>{{ text.ZMS_PVCODE1 }}</h6>
          {{ text.ZMS_PVTEXTE }}
        </div>
        <div class="textstorecord__readermode__phonetic">
          <h6>Phonétique / Consignes</h6>

          @if (text.ZMS_PVPHONETIQUE !== '') {
<div>
            {{ text.ZMS_PVPHONETIQUE }}
          </div>
} @else {

            <div class="textstorecord__readermode__nophonetic">
              Pas d'indication de phonétique ou de consignes
            </div>
          
}
          
        </div>

        @if (text.PROVISOIRE === 'OUI') {
<div  class="textstorecord__readermode__provisoire" ngbTooltip="Texte provisoire.">
          <i class="fa-solid fa-clock-rotate-left"></i>
        </div>
}
      </div>
    </div>
}
  </app-dialog>
}
</div>
